import { render, staticRenderFns } from "./sharePage.vue?vue&type=template&id=6219a086&scoped=true&"
import script from "./sharePage.vue?vue&type=script&lang=ts&"
export * from "./sharePage.vue?vue&type=script&lang=ts&"
import style0 from "./sharePage.vue?vue&type=style&index=0&id=6219a086&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6219a086",
  null
  
)

export default component.exports